import _ from 'lodash'
const USER_URL = process.env.USER_ENDPOINT

export default {
  computed: {
    userEndPoint: () => USER_URL,
    userImageUrl: () => USER_URL + '/image?id=',
    userHelpMarkURL: () => USER_URL + '/help/mark.html',
    workstyleHelpMarkURL: () => USER_URL + '/help/remotework.html',
    changeHighlightId: () => 'change',
    entryFormTypeMap () {
      return {
        simple: 'SIMPLE', // シンプル応募（自己PR不要）
        light: 'LIGHT' // ライト応募（自己PRと職歴不要）
      }
    },
    targetIdMap () { // コンテンツの描画エリアのID
      // HTMLタグへid埋め込み用に、master_jobpreview_highlight_identifierの内容を転記
      return {
        jobName: 'job-name',
        salaryMap: 'salary-map',
        overtimeWorkHours: 'indication-overtime-label',
        jobPrIcons: {
          1: 'pr-icon-inexperience-welcome',
          5: 'pr-icon-no-educational-background',
          27: 'pr-icon-secondary-new-graduates',
          77: 'pr-icon-veteran-ok',
          76: 'pr-icon-multiple-people-recruitment',
          53: 'pr-icon-weekend2-days',
          52: 'pr-icon-holiday120-date',
          64: 'pr-icon-bonus-monthly',
          13: 'pr-icon-listed-company',
          17: 'pr-icon-no-transfer',
          75: 'pr-icon-saturday-and-sunday-interview',
          61: 'pr-icon-interview1-time'
        },
        mainTitle: 'main-title',
        mainBody: 'main-body',
        mainPhoto: 'main-photo',
        background: 'background',
        jobDescription: 'contents',
        projectsDealing: 'projects-dealing',
        commodity: 'commodity',
        scopeJob: 'scope-job',
        salesStyle: 'sales-style',
        merchandiseDeal: 'merchandise-deal',
        attentionPoint1: 'attention-point-1',
        attentionPoint2: 'attention-point-2',
        timeSchedule: 'timeschedule',
        careerPath: 'mastered-skill',
        supportAfterJoin: 'after-support',
        requiredSkill: 'application-skill',
        welcomeSkill: 'desirable-capability',
        recruitExample: 'adoption-ex',
        suitablePerson: 'orient',
        employmentStatus: 'employments',
        trialPeriodText: 'trial-period-text',
        trialPeriodEmploymentStatusRemarks: 'trial-period-employment-status-remarks',
        salary: 'salary',
        salaryByWorkplaceAddressListText: 'salary-by-workplace-address-list-text',
        deemedOvertimeHoursText: 'deemed-overtime-hours-text',
        salaryExample: 'salary-ex',
        bonus: 'bonus',
        workSystemText: 'work-system-text',
        officeHours: 'office-hours',
        overTime: 'over-time',
        jobPlace: 'job-place',
        transportation: 'transportation',
        places: 'place-list',
        workplaceAddressListText: 'workplace-address-list-text',
        workstyle: 'workstyle-label',
        workstyleNote: 'workstyle-note',
        vacation: 'vacation',
        jobCondition: 'job-condition',
        smokingRuleText: 'smoking-rule-text',
        maternityChildcare: 'maternity-childcare',
        message: {
          prefix: 'sugao-topics-',
          title: 'sugao-topics-title',
          body: 'sugao-topics-body',
          photo: 'sugao-topics-photo',
          photoCaption: 'sugao-topics-photo-caption'
        },
        interviewBody: 'sugao-interview-body',
        sugaoPhoto: 'sugao-photo',
        sugaoPhotoCaption: 'sugao-photo-caption',
        companyDescription: 'enterprise-contents',
        mediaCoverage: 'media-coverage-result',
        mainClient: 'main-customer',
        established: 'established',
        employeesNum: 'employees-all',
        averageAge: 'average-age',
        employeesSexRatio: 'employees-sex-ratio',
        middleEnterRatio: 'middle-enter',
        capital: 'capital',
        salesAmount: 'sales-amount',
        presidentName: 'president-name',
        presidentHistory: 'president-history',
        process: 'process',
        processDetail: 'process-detail',
        homepageUrl: 'url',
        address: 'address',
        links: ['link-1', 'link-2', 'link-3'],
        code: {
          prefix: 'code-',
          companyName: 'code-company-name',
          business: 'code-business',
          jobNameForAdmUser: 'code-job-adm-name',
          jobNameForIndeed: 'code-job-indeed-name',
          jobType: 'code-job-type',
          jobPrimary: 'code-job-primary',
          jobOther: 'code-job-other',
          employments: 'code-employments',
          salaryExample: 'code-salary-example',
          places: 'code-places',
          workstyle: 'code-workstyle',
          overtimeWorkHours: 'code-indication-overtime-label',
          prCode: 'code-job-pr',
          jobSkill: 'code-job-skill',
          jobLicenses: 'code-job-licenses',
          applicationUrl: 'code-application-url',
          question: 'code-question',
          isSecretPlan: 'code-secret-plan-flag',
          companyStaff: 'code-company-staff',
          displayCompanyName: 'code-display-company-name',
          officialCompanyName: 'code-official-company-name'
        },
        profile: {
          prefix: 'matching-profile-',
          matchingSettingStatus: 'matching-profile-stop-flag',
          gender: 'matching-profile-sex',
          age: 'matching-profile-age',
          matchingPlaces: 'matching-profile-area',
          educationLevel: 'matching-profile-education-label',
          graduateYear: 'matching-profile-graduation',
          educationalSearchWord: 'matching-profile-education-name',
          userWorkStatus: 'matching-profile-work-status',
          usersIncomeRange: 'matching-profile-salary'
        },
        experience: {
          prefix: 'matching-experience-',
          jobExperienceList: 'matching-experience-job-list',
          business: 'matching-experience-business'
        },
        language: {
          prefix: 'matching-language-',
          score: 'matching-language-score',
          englishLevel: 'matching-language-english-skill'
        },
        skill: {
          prefix: 'matching-skill-',
          1: 'matching-skill-it',
          3: 'matching-skill-electrical',
          4: 'matching-skill-chemistry',
          5: 'matching-skill-consulting',
          6: 'matching-skill-sales',
          7: 'matching-skill-supply',
          8: 'matching-skill-planging-backoffice',
          9: 'matching-skill-finance',
          10: 'matching-skill-others',
          11: 'matching-skill-createive'
        },
        license: {
          prefix: 'matching-license-',
          10: 'matching-license-it',
          8: 'matching-license-technical',
          9: 'matching-license-general'
        },
        freeword: {
          prefix: 'matching-freeword-',
          freeWord: 'matching-freeword-name'
        },
        registrationDate: 'matching-targetdate',
        personalityQuestion: {
          prefix: 'personality-question-',
          questions: [
            ['personality-question-01',
              'personality-question-02',
              'personality-question-03',
              'personality-question-04',
              'personality-question-05'],
            ['personality-question-06',
              'personality-question-07',
              'personality-question-08',
              'personality-question-09'],
            ['personality-question-10',
              'personality-question-11',
              'personality-question-12',
              'personality-question-13',
              'personality-question-14',
              'personality-question-15']]
        }
      }
    }
  },
  methods: {
    // 画面にハイライトを付与する。マウント時に呼び出す。
    setHighlight (commentHighlight) {
      if (!commentHighlight.highlight) return // ハイライト情報がない場合は描画不要
      const element = document.getElementById(commentHighlight.target)
      if (_.get(element, 'tagName') === 'IMG') {
        // 画像ハイライト
        this.$emit('setImgHighlight', element, commentHighlight)
        return
      }

      const highlightRange = this.getTargetRange(commentHighlight, element)
      if (!highlightRange) return
      // ハイライトの付与（DOM書き換え）
      const newHighlight = document.createElement('mark')
      let highlightClass = this.changeHighlightId // 初期値：「文字列に変更あり」クラス
      let highlightTargetText = highlightRange.toString()
      // ハイライト箇所に含まれていたCRLFの数
      const crlfCount = commentHighlight.highlight.crlfCount
      if (crlfCount > 0) {
        // TODO ※改行コード統一対応（2024/7月リリース）のため、リリース後、時期を見て削除
        // 改行コードをcrlfからlfに統一した結果、50文字超過+改行込みのハイライトがchangeHighlightになってしまう
        // そのため、crlfCount（ハイライト箇所に含まれていたcrlfの数）を減算した文字列での比較が必要
        // crlfCountが全て0になったら、この分岐は不要
        highlightTargetText = (highlightTargetText.length + crlfCount) > 50 ? highlightTargetText.substring(0, 50 - crlfCount) + '...' : highlightTargetText
      } else {
        highlightTargetText = highlightTargetText.length > 50 ? highlightTargetText.substring(0, 50) + '...' : highlightTargetText
      }
      if (highlightTargetText === commentHighlight.text) {
        // 文字列に変更がない場合は、ハイライトクラスを各ロールの色にする
        highlightClass = commentHighlight.isCompanyStaff ? 'boss' : 'adm'
      }
      newHighlight.className = 'pega-highlight-' + highlightClass
      newHighlight.id = this.createHighlightId(commentHighlight.target, commentHighlight.highlight.start)

      newHighlight.appendChild(highlightRange.extractContents())
      highlightRange.insertNode(newHighlight)
    },

    // 対象のRangeを取得
    getTargetRange (commentHighlight, element) {
      const targetRange = document.createRange()
      const startNodeInfo = this.getTargetNode(element, commentHighlight.highlight.start)
      const endNodeInfo = this.getTargetNode(element, commentHighlight.highlight.end)
      if (this.cantGetRangeTargetNode(startNodeInfo, endNodeInfo) ||
          this.isZeroRangeHighlight(startNodeInfo, endNodeInfo)) {
        this.cantHighlight(commentHighlight)
        return null
      }
      targetRange.setStart(startNodeInfo.node, startNodeInfo.offset)
      if (endNodeInfo.node.length < endNodeInfo.offset) {
        targetRange.setEnd(endNodeInfo.node, endNodeInfo.node.length)
      } else {
        targetRange.setEnd(endNodeInfo.node, endNodeInfo.offset)
      }
      return targetRange
    },

    // ターゲットノードが正しく取得できない
    cantGetRangeTargetNode (startNodeInfo, endNodeInfo) {
      return !startNodeInfo || !startNodeInfo.node ||
      !endNodeInfo || !endNodeInfo.node ||
      startNodeInfo.node.length < startNodeInfo.offset
    },

    // 対象ノード開始終了が同値になっている(例：文書変更の結果、末尾0文字ハイライト)
    isZeroRangeHighlight (startNodeInfo, endNodeInfo) {
      return startNodeInfo.node === endNodeInfo.node &&
      startNodeInfo.offset === endNodeInfo.offset
    },

    // 対象のNodeを取得
    getTargetNode (element, offset) {
      // elementが取れない場合には、idが変わっているためエラー終了とする
      if (!element) return null

      // elementの先頭から走査し、offset分考慮したnodeを検出する。
      // また、offsetの値も、対象node内のoffsetに合わせて算出する

      // 記録用オブジェクトを初期化
      const target = {
        node: undefined,
        textCount: 0,
        lastCount: 0
      }

      _.forEach(element.childNodes, (node) => {
        target.node = node
        if (target.node.length) {
          target.lastCount = target.textCount
          target.textCount += target.node.length
          if (target.textCount >= offset) return false // 処理終了
        } else {
          // 子ノードが入れ子の場合中を走査
          this.searchChildNodes(target.node.childNodes, offset, target)
          // 入れ子ノード走査中に対象ノードが見つかった場合、親ループをbreakするため再度同一の判定を実施
          if (target.textCount >= offset) return false // 処理終了
        }
      })
      return { node: target.node, offset: offset - target.lastCount }
    },

    // 子ノードの検索
    searchChildNodes (childNodes, offset, target) {
      _.forEach(childNodes, (childNode) => {
        if (childNode.nodeName === '#text') {
          target.node = childNode
          target.lastCount = target.textCount
          target.textCount += target.node.length
          if (target.textCount >= offset) return false // 処理終了
        } else if (childNode.firstChild) {
          this.searchChildNodes(childNode.childNodes, offset, target)
          // 入れ子ノード走査中に対象ノードが見つかった場合、親ループをbreakするため再度同一の判定を実施
          if (target.textCount >= offset) return false // 処理終了
        }
      })
    },

    // ハイライト不可処理
    cantHighlight (commentHighlight) {
      this.$toasted.global.error({ message: 'ハイライトできない領域が指定されたため、ハイライト情報を削除しました。対象: ' + commentHighlight.text })
      this.$emit('deleteHighlight', commentHighlight)
    },

    //  ハイライトIDの生成
    createHighlightId (target, index) {
      return 'highlight-' + target + '-' + index
    }
  }
}
